import React, { Component, useCallback } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import noop from "lodash/noop";
import {
  addAccountFavorite,
  removeAccountFavorite,
  addProductGroupFavorite,
  removeProductGroupFavorite,
  addOpportunityFavorite,
  removeOpportunityFavorite

} from "../../actions/userActions";
import FavoriteItem from "./ModalListItems/FavoriteItem";
import CloseButton from "./CloseButton";
import AccountSearchSelectList from "../SelectLists/Types/AccountSearchSelectList";
import ProductGroupSearchSelectList from "../SelectLists/Types/ProductGroupSearchSelectList";
import OpportunitySearchSelectList from "../SelectLists/Types/OpportunitySearchSelectList";

// SASS Imports
require("./Modal.scss");
require("./FavoritesModal.scss");

class FavoritesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addingOpen: false,
      accountsActive: true,
      productGroupsActive: false,
      opportunitiesActive: false,
    };
  }

  render() {
    let Content;

    if (!this.state.addingOpen) {
      let items = [];
      let itemType = "";
      let label = "";

      if (this.state.accountsActive) {
        itemType = "account";
        items = this.props.accounts;
        label = "Accounts";
      } else if (this.state.productGroupsActive) {
        itemType = "productGroup";
        items = this.props.productGroups;
        label = "Product Groups";
      } else if (this.state.opportunitiesActive) {
        itemType = "opportunity";
        items = this.props.opportunities;
        label = "Opportunities";
      }

      if(items.length > 0) {
        Content = items.map(function(item){
          const style = `btn-delete`;

          return <FavoriteItem key={item.getId()} type={itemType} content={item} buttonStyle={style} addFav={false} />;
        });
      }

      Content = (
        <div className="searchSelectList">
          <div className="searchListResultWrapper">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xs-12 favorites-bar">
                  <h6>My Favorites</h6>
                </div>
              </div>
              {Content}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="modalPanel favoritesModal searchListModal">
        {
          this.props.closeModal ?
            <button className="close" onClick={ this.props.closeModal }>
              <CloseButton />
            </button> :
            null
        }
        <div className="modalWrap">
          <div className="modalHeader text-center">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-4 col-xs-6 addNew">
                  {this.state.addingOpen
                    ? <button onClick={() => this.setState({ addingOpen: false }) } className="btn-add">Back</button>
                    : <button onClick={() => this.setState({ addingOpen: true }) } className="btn-add">Add Favorite</button>}
                </div>
                <div className="col-sm-4 col-xs-6 no-padding">
                  <h4>Favorites</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="favoritesToggle">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xs-4 text-center no-padding toggleOption">
                  <button className={classNames({ active: this.state.accountsActive })} onClick={() => this.setState({ accountsActive: true, productGroupsActive: false, opportunitiesActive: false }) }>
                    <h6>Accounts</h6>
                  </button>
                </div>

                <div className="col-xs-4 text-center no-padding toggleOption">
                  <button className={classNames({ active: this.state.productGroupsActive })} onClick={() => this.setState({ accountsActive: false, productGroupsActive: true, opportunitiesActive: false }) }>
                    <h6>Product Groups</h6>
                  </button>
                </div>

                <div className="col-xs-4 text-center no-padding toggleOption">
                  <button className={classNames({ active: this.state.opportunitiesActive})} onClick={() => this.setState({ accountsActive: false, productGroupsActive: false, opportunitiesActive: true }) }>
                    <h6>Opportunities</h6>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={this.props.closeModal ? "modalContent" : "modalContent onBoardingModal"} >
            {Content}

            <AccountSearchSelectList
              showStaticList={false}
              isHidden={!this.state.accountsActive || !this.state.addingOpen}
              itemProps={{
                actions: noop,
                hasAddToFavorites: true,
                onFavoriteItem: this.props.addAccountFavorite,
                onRemoveFavoriteItem: this.props.removeAccountFavorite,
              }}
              onSelectItem={this.props.toggleFavoriteAccount}
            />

            <ProductGroupSearchSelectList
              showStaticList={false}
              isHidden={!this.state.productGroupsActive || !this.state.addingOpen}
              itemProps={{
                actions: noop,
                hasAddToFavorites: true,
                onFavoriteItem: this.props.addProductGroupFavorite,
                onRemoveFavoriteItem: this.props.removeProductGroupFavorite,
              }}
              onSelectItem={this.props.toggleFavoriteProductGroup}
            />

            <OpportunitySearchSelectList
              showStaticList={false}
              isHidden={!this.state.opportunitiesActive || !this.state.addingOpen}
              itemProps={{
                actions: noop,
                hasAddToFavorites: true,
                onFavoriteItem: this.props.addOpportunityFavorite,
                onRemoveFavoriteItem: this.props.removeOpportunityFavorite,
              }}
              onSelectItem={this.props.toggleOpportunityAccount}
            />

            <Footer closeModal={this.props.closeModal} nextStep={this.props.nextStep} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    accounts: state.favorites.accounts,
    productGroups: state.favorites.productGroups,
    opportunities: state.favorites.opportunities
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    addAccountFavorite: (account) =>
    dispatch(addAccountFavorite(account)),
    removeAccountFavorite: (account) =>
    dispatch(removeAccountFavorite(account)),
    toggleFavoriteAccount: (account) => account.isFavorite()
    ? dispatch(removeAccountFavorite(account))
    : dispatch(addAccountFavorite(account)),
    addProductGroupFavorite: (productGroup) =>
    dispatch(addProductGroupFavorite(productGroup)),
    removeProductGroupFavorite: (productGroup) =>
    dispatch(removeProductGroupFavorite(productGroup)),
    toggleFavoriteProductGroup: (productGroup) => productGroup.isFavorite()
    ? dispatch(removeProductGroupFavorite(productGroup))
    : dispatch(addProductGroupFavorite(productGroup)),
    addOpportunityFavorite: (opportunity) =>
    dispatch(addOpportunityFavorite(opportunity)),
    removeOpportunityFavorite: (opportunity) =>
    dispatch(removeOpportunityFavorite(opportunity)),
    toggleOpportunityAccount: (opportunity) => opportunity.isFavorite()
    ? dispatch(removeOpportunityFavorite(opportunity))
    : dispatch(addOpportunityFavorite(opportunity)),
  };
}



export default connect(mapStateToProps, mapDispatchToProps)(FavoritesModal);

function Footer({ closeModal, nextStep }) {
  const onClose = useCallback(function() {
    if (typeof nextStep === "function") {
      nextStep();
    }
  }, [nextStep]);

  if (!closeModal && !nextStep) {
    return null;
  }

  return (
    <div className="row save">
      <div className="saveButton col-sm-4 col-xs-6 col-sm-offset-4 col-xs-offset-3">
        <button className="btn-submit" onClick={onClose}>{closeModal ? "Save" : "Continue"}</button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/components/Modals/FavoritesModal.jsx